module.exports = __webpack_public_path__ + "img/produto_pass.d04bab53.png";